import React from 'react';
import { Image } from '@thd-olt-component-react/core-ui';
import { generateImageSource } from '../../../../utils/generateImageSource';

const EditTemplateTip = ({ hasTemplate }) => {

  if (!hasTemplate) {
    return null;
  }

  return (
    <div className="create-job-posting__tooltip-section" data-testid="pro-tip-edit-template-tip">
      <div className="create-job-posting__tip-label">
        <p>
          <Image
            src={generateImageSource('/images/v1/path-to-pro/light-bulb-orange.svg')}
            alt="trade icon"
            data-testid="tradeTypeIcon"
          />
          <span style={{ paddingLeft: '10px' }}>
            Edit the Template
          </span>
        </p>
      </div>
      <p>Make sure you edit your template, to let candidates know any unique tasks or requirements needed for your job.</p>
    </div>
  );
};

export default EditTemplateTip;